import { render, staticRenderFns } from "./AssignedResourcesChips.vue?vue&type=template&id=9764285a&"
import script from "./AssignedResourcesChips.vue?vue&type=script&lang=js&"
export * from "./AssignedResourcesChips.vue?vue&type=script&lang=js&"
import style0 from "./AssignedResourcesChips.vue?vue&type=style&index=0&module=true&lang=less&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./AssignedResourcesChips.vue?vue&type=style&index=0&module=true&lang=less&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./AssignedResourcesChips.vue?vue&type=style&index=0&module=true&lang=less&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("9764285a")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9764285a')) {
      api.createRecord('9764285a', component.options)
    } else {
      api.reload('9764285a', component.options)
    }
    module.hot.accept("./AssignedResourcesChips.vue?vue&type=template&id=9764285a&", function () {
      api.rerender('9764285a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/buttons/includes/AssignedResourcesChips.vue"
export default component.exports